import DiamondEmpty from './src/diamond-empty-combined';
export default DiamondEmpty;